import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Dropdown, MenuItem } from 'react-bootstrap';

import { startEmailGroup } from './store/actions/requirements_set';

export class RequirementsSetActionsDropdown extends React.Component {
  static propTypes = {
    canAccessCrm: PropTypes.bool.isRequired,
    requirementsSets: PropTypes.array.isRequired,
    onCreateEmailGroup: PropTypes.func.isRequired,
  };

  handleEmailToGroup = () => {
    const { onCreateEmailGroup } = this.props;
    onCreateEmailGroup(this.requirementsSetsParents());
  };

  isDisabled = () => {
    const { canAccessCrm, requirementsSets } = this.props;
    return !canAccessCrm || requirementsSets.length < 1;
  }

  render() {
    return (
      this.renderDropdown()
    );
  }

  renderDropdown() {
    const { requirementsSets } = this.props;
    return (
      <Dropdown className="mr-4" disabled={this.isDisabled()} id="actions-dropdown">
        <Dropdown.Toggle>
          Actions
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {requirementsSets.length > 0 && this.renderDisplayedRequirementSetsOptions()}
        </Dropdown.Menu>
      </Dropdown>
    );
  }

  renderDisplayedRequirementSetsOptions() {
    const { canAccessCrm } = this.props;
    return (
      <React.Fragment>
        {canAccessCrm && (
          <MenuItem name="email-group" onClick={this.handleEmailToGroup}>Email Contacts</MenuItem>
        )}
      </React.Fragment>
    );
  }

  requirementsSetsParents() {
    const { requirementsSets } = this.props;
    return requirementsSets.map(rs => ({ contactId: rs.parentId, contactType: rs.parentType }));
  }
}

const mapStateToProps = state => ({
  canAccessCrm: state.static.canAccessCrm,
  requirementsSets: state.search.requirementsSets,
});

const mapDispatchToProps = {
  onCreateEmailGroup: startEmailGroup,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequirementsSetActionsDropdown);
